import React, { useContext } from 'react'

export const LayoutContext = React.createContext({
  isSideMenuOpen: false,
  whoAmI: null
})

export const useLayoutContext = () => useContext(LayoutContext)
